import keyMirror from 'react-utils/keyMirror';
import EmailAddressesAPI from '../api/EmailAddressesAPI';
import { createAction, createRequestTypes, createRequestActions } from './utils';
export const EmailAddressActionTypes = keyMirror({
  LOAD_EMAIL_ADDRESSES: null,
  ADD_EMAIL_ADDRESS: null,
  EDIT_EMAIL_ADDRESS: null,
  RESEND_PENDING_CONFIRMATION: null,
  CANCEL_PENDING_EMAIL_ADDRESS: null,
  REMOVE_EMAIL_ADDRESS: null,
  ADD_EMAIL: null,
  DELETE_EMAIL: null,
  RESEND_VERIFICATION: null,
  SET_PRIMARY: null
});
export const FETCH_EMAIL_ADDRESSES = 'FETCH_EMAIL_ADDRESSES';
export const ADD_EMAIL_ADDRESS = 'ADD_EMAIL_ADDRESS';
export const EDIT_EMAIL_ADDRESS = 'EDIT_EMAIL_ADDRESS';
export const RESEND_PENDING_CONFIRMATION = 'RESEND_PENDING_CONFIRMATION';
export const CANCEL_PENDING_EMAIL_ADDRESS = 'CANCEL_PENDING_EMAIL_ADDRESS';
export const REMOVE_EMAIL_ADDRESS = 'REMOVE_EMAIL_ADDRESS';
export const ADD_EMAIL = 'ADD_EMAIL';
export const DELETE_EMAIL = 'DELETE_EMAIL';
export const RESEND_VERIFICATION = 'RESEND_VERIFICATION';
export const SET_PRIMARY = 'SET_PRIMARY';
export const FetchEmailAddressesActionTypes = createRequestTypes(FETCH_EMAIL_ADDRESSES);
export const FetchEmailAddresses = createRequestActions(FetchEmailAddressesActionTypes);
export const loadEmailAddresses = () => createAction(EmailAddressActionTypes.LOAD_EMAIL_ADDRESSES);
export const AddEmailAddressActionTypes = createRequestTypes(ADD_EMAIL_ADDRESS);
export const AddEmailAddress = createRequestActions(AddEmailAddressActionTypes);
export const addEmailAddress = emailAddress => createAction(EmailAddressActionTypes.ADD_EMAIL_ADDRESS, {
  data: emailAddress
});
export const EditEmailAddressActionTypes = createRequestTypes(EDIT_EMAIL_ADDRESS);
export const EditEmailAddress = createRequestActions(EditEmailAddressActionTypes);
export const editEmailAddress = (emailAddress, password) => dispatch => {
  dispatch({
    type: EditEmailAddressActionTypes.REQUEST,
    payload: {
      data: {
        emailAddress,
        password
      }
    }
  });
  EmailAddressesAPI.editEmailAddress({
    emailAddress,
    password
  }).then(() => {
    dispatch({
      type: EditEmailAddressActionTypes.SUCCESS,
      payload: {
        props: emailAddress
      }
    });
  }).catch(err => {
    dispatch({
      type: EditEmailAddressActionTypes.FAILURE,
      payload: {
        error: err,
        props: emailAddress
      }
    });
  });
};
export const ResendPendingConfirmationActionTypes = createRequestTypes(RESEND_PENDING_CONFIRMATION);
export const ResendPendingConfirmation = createRequestActions(ResendPendingConfirmationActionTypes);
export const resendPendingConfirmation = emailAddress => createAction(EmailAddressActionTypes.RESEND_PENDING_CONFIRMATION, {
  data: emailAddress
});
export const CancelPendingEmailAddressActionTypes = createRequestTypes(CANCEL_PENDING_EMAIL_ADDRESS);
export const CancelPendingEmailAddress = createRequestActions(CancelPendingEmailAddressActionTypes);
export const cancelPendingEmailAddress = emailAddress => createAction(EmailAddressActionTypes.CANCEL_PENDING_EMAIL_ADDRESS, {
  data: emailAddress
});
export const RemoveEmailAddressActionTypes = createRequestTypes(REMOVE_EMAIL_ADDRESS);
export const RemoveEmailAddress = createRequestActions(RemoveEmailAddressActionTypes);
export const removeEmailAddress = emailAddress => createAction(EmailAddressActionTypes.REMOVE_EMAIL_ADDRESS, {
  data: emailAddress
});
export const AddEmailActionTypes = createRequestTypes(ADD_EMAIL);
export const AddEmail = createRequestActions(AddEmailActionTypes);
export const addEmail = email => createAction(EmailAddressActionTypes.ADD_EMAIL, {
  data: email
});
export const DeleteEmailActionTypes = createRequestTypes(DELETE_EMAIL);
export const DeleteEmail = createRequestActions(DeleteEmailActionTypes);
export const deleteEmail = id => createAction(EmailAddressActionTypes.DELETE_EMAIL, {
  data: id
});
export const ResendVerificationActionTypes = createRequestTypes(RESEND_VERIFICATION);
export const ResendVerification = createRequestActions(ResendVerificationActionTypes);
export const resendVerification = id => createAction(EmailAddressActionTypes.RESEND_VERIFICATION, {
  data: id
});
export const SetPrimaryActionTypes = createRequestTypes(SET_PRIMARY);
export const SetPrimary = createRequestActions(SetPrimaryActionTypes);
export const setPrimary = id => createAction(EmailAddressActionTypes.SET_PRIMARY, {
  data: id
});